import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractService } from './abstract.service';
import { LoginService } from './login.service';
import { CicloVidaLicenca } from '../models/ciclo-vida-licenca';

@Injectable({
  providedIn: 'root'
})
export class CicloVidaService extends AbstractService<CicloVidaLicenca> {
  titulo: string = "Ciclo de vida das licenças";

  endpoint(): string {
    return "/registro/ciclo-vida"
  }
  rotina(): string {
    return "CICLO_VIDA"
  }
  colunas(): any[] {
    return [
      { header: "Código", field: "id" },
      { header: "Descrição", field: "nome" },
    ];

  }
  novo(selection?: any) {
    AbstractService.readonly = false;
    this.router.navigate([this.uri()])
  }
  abrir(obj: CicloVidaLicenca) {
    AbstractService.readonly = true;
    this.router.navigate([this.uri()], { queryParams: { id: obj.id } });
  }
  edit(obj: CicloVidaLicenca) {
    AbstractService.readonly = false;
    this.router.navigate([this.uri()], { queryParams: { id: obj.id } });
  }
  routeLista() {
    return this.uri(true)
  }

  private uri(ehLista?: boolean): string {
    let ret = "/adm/ciclos-vida";
    if (ehLista) {
      return ret;
    }
    return ret + "/cadastro";
  }

  constructor(http: HttpClient, loginService: LoginService, private router: Router) {
    super(http, loginService);
  }
}
